import type { SVGProps } from "react";
export interface FishIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FishIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FishIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.623.884a3.6 3.6 0 0 1 3.494 3.492c.089 2.929-.54 5.518-1.702 7.642.18.595.39 1.5.4 2.531.012 1.413-.357 3.13-1.767 4.565-.329.335-.832.43-1.26.238a6.3 6.3 0 0 1-2.708-2.295c-1.252.561-2.753.926-4.263.998.057 1.34-.324 3.228-2.332 4.825a1.12 1.12 0 0 1-1.286.08c-1.618-.985-2.42-2.195-2.792-3.253a5 5 0 0 1-.225-.89 5 5 0 0 1-.89-.225C3.235 18.22 2.026 17.418 1.04 15.8a1.13 1.13 0 0 1 .08-1.286c1.593-2.002 3.478-2.388 4.817-2.333a11.3 11.3 0 0 1 1.01-4.26 6.3 6.3 0 0 1-2.298-2.707 1.125 1.125 0 0 1 .24-1.261c1.434-1.41 3.151-1.781 4.564-1.768 1.03.009 1.935.22 2.53.4 2.124-1.163 4.713-1.79 7.642-1.701Zm-.067 2.248c-2.751-.083-5.069.555-6.87 1.64-.29.176-.645.212-.964.096-.38-.138-1.267-.424-2.29-.433-.769-.007-1.573.14-2.307.599.643.89 1.461 1.25 1.813 1.42a1.124 1.124 0 0 1 .48 1.584c-.934 1.584-1.37 3.441-1.209 5.388a1.124 1.124 0 0 1-1.511 1.147c-.33-.123-1.828-.512-3.248.74.568.679 1.141.999 1.59 1.157.6.211 1.027.164 1.2.164.622 0 1.125.504 1.126 1.125 0 .174-.048.6.164 1.2.157.449.477 1.023 1.156 1.59 1.251-1.42.863-2.915.74-3.246a1.126 1.126 0 0 1 1.15-1.513c1.946.162 4.047-.38 5.366-1.195l.104-.058a1.126 1.126 0 0 1 1.5.525c.17.351.53 1.168 1.42 1.81.457-.732.607-1.536.6-2.304-.009-1.023-.296-1.91-.433-2.29a1.13 1.13 0 0 1 .094-.965c1.085-1.8 1.723-4.117 1.64-6.868a1.35 1.35 0 0 0-1.31-1.313Z"
      />
      <path
        fill={color}
        d="M16.5 6.629a.62.62 0 0 0-.125.37l.012.126c.019.091.06.173.113.245zm1 .741a.6.6 0 0 0 .112-.245L17.625 7l-.013-.126a.6.6 0 0 0-.111-.244zM18.625 7a1.625 1.625 0 0 1-3.242.167l-.008-.168.009-.165A1.625 1.625 0 0 1 17 5.374l.166.01c.82.083 1.46.774 1.46 1.615Z"
      />
    </svg>
  );
}
